export default __webpack_public_path__ + "static/subset-DrukTextWideCyr-Medium-46786661b3ce682b068b7db826fbd755.woff";